module.exports = __webpack_public_path__ + "img/content6-2.9c9e4ba9.png";